module.exports = __webpack_public_path__ + "img/CU.8ea1c420.svg";